export class TipoAcao{
  descricao: string;
  id: number;
}
